<template lang="pug">
#betHistory.tab-pane.nopad.fade.show.active
  template(v-if="showGameResult")
    gameResult(:category="category" @getDifferentPage="getDifferentPage")
  template(v-else)
    .table-responsive.statement-web
      table.table-history
        thead
          tr
            th ID
            th {{$t('ui.platform')}} 
            th {{$t('ui.winlose')}} 
            th {{$t('ui.date')}}
        template(v-if="platformData.length > 0")
          tbody
            tr(v-for="item in platformData")
              td.text-center {{item.account_id}}
              td.text-center {{item.category}}
              td.text-center 
                a(href="javascript:void('0')" :class="getColor(item.winlose)" @click.stop="getMemberGameResult(item.category, $moment(item.working_date).format('YYYY-MM-DD'))") {{item.winlose}}
              td.text-center {{ $moment(item.working_date).format("YYYY-MM-DD") }}
        template(v-else)
          tbody
            tr
              td(colspan="4") {{ $t('ui.no_record') }}
    .statement-mob
      .statement-history
        template(v-if="platformData.length > 0")
          .statement-history-content(v-for="item in platformData")
            .statement-history-left
              .statement-history-date.no-uppercase  {{item.account_id}}
              .statement-history-game {{ $moment(item.working_date).format("YYYY-MM-DD") }}
            .statement-history-right
              .statement-history-id {{item.category}}                
              .statement-history-amount
                a(href="javascript:void('0')" :class="getColor(item.winlose)" @click.stop="getMemberGameResult(item.category, $moment(item.working_date).format('YYYY-MM-DD'))") {{item.winlose}}
                  i.fa-solid.fa-circle-chevron-right.ms-1 
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import gameResult from '@/components2/statement/_betDetails.vue'
export default {
  components:{
    gameResult,
  },
  props:{   
    platformData: {
      type: Array,
      default: []
    },
    reportDetails:{
      type: Boolean,
    }
  },
  data() {
    return {
      url : "",
      path: "",
      showGameResult: false,
      category: "",
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
  },
  beforeDestroy(){
    this.reset()
  },
  mounted() {
    window.scroll(0, 0)
    if(!this.reportDetails){
      this.showGameResult = false
    }
  },
  methods: {
    getColor(value) {
      if (value > 0) {
        return "text-success";
      } else if (value < 0) {
        return "text-danger";
      } else {
        return "";
      }
    },
    getText(value) {
      if (value > 0) {
        return "ui.win";
      } else if (value < 0) {
        return "ui.lose";
      } else {
        return "ui.tie";
      }
    },
    getDifferentPage(e){
      this.getMemberGameResult(e.category, e.workingDate, e.pageSize, e.newPage)
    },
    getMemberGameResult(option, workingDate, page_size, page_number){
      switch(option){
        case "LIVECASINO":
          this.url = config.getGameResultLivecasino()
          this.path = "user/sLivecasinoResult"
          this.category = "LIVECASINO"
          break;

        case "SLOTS":
          this.url = config.getGameResultSlot()
          this.path = "user/sSlotResult"
          this.category = "SLOTS"
          break;

        case "REBATE":
          this.url = config.getGameResultRebate()
          this.path = "user/sRebateResult"
          this.category = "REBATE"
          break;

        case "SPORTSBOOK":
          this.url = config.getGameResultSb()
          this.path = "user/sSbResult"
          this.category = "SPORTSBOOK"
          break;
        default:
          break;
      }
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let url = this.url
        let working_date = workingDate
        let category = this.category
        this.$store
          .dispatch("user/getMemberGameResult", { account_id, working_date, page_size, page_number, auth_token, url, category })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch(this.path, { data: response.data, size: 10, index: 1, working_date: working_date })
                .then(() => {
                  this.showGameResult = true
                  this.$emit("platformSelected", this.category)
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    reset(){
      this.showGameResult = false
    }
  }
};
</script>
